import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { AuthProvider, withAuth } from '@/hooks/useAuth'
import { Layout } from '@/components/layout/Layout'
import { MerchantLayout } from '@/components/layout/MerchantLayout'
import { MerchantHome } from '@/pages/MerchantHome'
import { MerchantFunnel } from '@/components/funnel/MerchantFunnel'
import { FunnelControlCenter } from '@/components/funnel/FunnelControlCenter'
import { authService } from '@/api/auth'
import { DashboardPage } from '@/pages/DashboardPage'
import { ExperimentsPage } from '@/pages/ExperimentsPage'
import { ExperimentDetailsPage } from '@/pages/ExperimentDetailsPage'
import { ExperimentEditPage } from '@/pages/ExperimentEditPage'
import { ExperimentResultsPage } from '@/pages/ExperimentResultsPage'
import { ResultsPage } from '@/pages/ResultsPage'
import { CustomEventsPage } from '@/pages/CustomEvents'
import { SettingsPage } from '@/pages/SettingsPage'
import { LoginPage } from '@/pages/LoginPage'
import { AuthCallbackPage } from '@/pages/AuthCallbackPage'
import { AuthSuccessPage } from '@/pages/AuthSuccessPage'
import { InstallSuccessPage } from '@/pages/InstallSuccessPage'
import { ReactEditorTest } from '@/pages/ReactEditorTest'
import { CohortsPage } from '@/pages/CohortsPage'
import { GoalsPage } from '@/pages/GoalsPage'
import { QuestionsPage } from '@/pages/QuestionsPage'
// Nimbus design system: theme provider (root) + toast queue provider.
import { ThemeProvider as NimbusThemeProvider } from '@nimbus-ds/styles'
import { Toast } from '@nimbus-ds/components'

// Protected Layout components
const ProtectedLayout = withAuth(Layout)
const ProtectedMerchantLayout = withAuth(MerchantLayout)

// Merchants land on the standup view; consultants/owners get the full dashboard.
function DashboardIndex() {
  if (authService.isMerchant()) return <Navigate to="/merchant" replace />
  return <DashboardPage />
}

function App() {
  return (
    <AuthProvider>
      <NimbusThemeProvider>
        <Toast.Provider>
      <div className="min-h-screen bg-background">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/auth-success" element={<AuthSuccessPage />} />
          <Route path="/install-success" element={<InstallSuccessPage />} />
          <Route path="/react-editor-test" element={<ReactEditorTest />} />

          {/* Merchant standup view (lean, mobile-first) */}
          <Route path="/merchant" element={<ProtectedMerchantLayout />}>
            <Route index element={<MerchantHome />} />
            {/* Prototype: minimal one-leak/one-verb merchant screen */}
            <Route path="funnel" element={<MerchantFunnel />} />
            {/* Prototype: funnel control center (adaptive, phase panels) */}
            <Route path="control" element={<FunnelControlCenter />} />
          </Route>

          {/* Protected dashboard routes */}
          <Route path="/dashboard" element={<ProtectedLayout />}>
            <Route index element={<DashboardIndex />} />
            <Route path="experiments" element={<ExperimentsPage />} />
            <Route path="experiments/:id" element={<ExperimentDetailsPage />} />
            <Route path="experiments/:id/edit" element={<ExperimentEditPage />} />
            <Route path="experiments/:id/results" element={<ExperimentResultsPage />} />
            <Route path="results" element={<ResultsPage />} />
            <Route path="custom-events" element={<CustomEventsPage />} />
            <Route path="cohorts" element={<CohortsPage />} />
            <Route path="goals" element={<GoalsPage />} />
            <Route path="questions" element={<QuestionsPage />} />
            {/* Prototype: funnel control center (same adaptive component, consultant density) */}
            <Route path="funnel" element={<FunnelControlCenter />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>

        {/* Global toast notifications (bridges app toast() onto Nimbus Toast.Provider) */}
        <Toaster />
      </div>
        </Toast.Provider>
      </NimbusThemeProvider>
    </AuthProvider>
  )
}

export default App
